import { createFileRoute } from '@tanstack/react-router'
import { PengaturanDesa } from '../../../../components/PengaturanDesa'

export const Route = createFileRoute('/desa/$slug/dashboard/pengaturan')({
  component: () => {
    const { desaId } = Route.useRouteContext() as any
    if (!desaId) return null
    return <PengaturanDesa desaId={desaId} />
  },
})
